import BaseIdentifier from './BaseIdentifier'


class BlockIdentifier extends BaseIdentifier {
  constructor(pattern, hasIndentChildren = false, hasOptions = false) {
    super(pattern, null, false, hasOptions)
    this.hasIndentChildren = hasIndentChildren
  }
}

export default BlockIdentifier